module.exports = __webpack_public_path__ + "static/media/printIcon.dc5e6445.svg";